import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';

export const isTeamQueryValid = query => {
  return query?.trim().length >= 3;
};

export const getQueryResultTitleText = (query, resultCount) => {
  if (!isTeamQueryValid(query)) {
    return formatMessage(Messages.searchPage_searchQueryNotValid, {
      query: query,
    });
  }

  if (resultCount === 0) {
    return formatMessage(Messages.searchPage_noResultsForTeam, {
      query: query,
    });
  }
};

/**
 * Tries to find team where code prefix or agent code matches with search query.
 * If found and user ID matches code prefix then returns true, if not then returns false.
 */
export const shouldSearchAD = (query, teams) => {
  if (query.includes('-')) {
    let shouldSearchAd = false;
    teams.forEach(team => {
      if (team.agents.some(agent => agent.code?.toUpperCase() === query?.toUpperCase())) {
        shouldSearchAd = team.userId !== team.codePrefix;
        return;
      }
    });
    return shouldSearchAd;
  } else {
    const team = teams.find(x => x.codePrefix?.toUpperCase() === query?.toUpperCase());
    return team && team.userId !== team.codePrefix;
  }
};

export const searchTypes = {
  team: 'team',
  employer: 'employer',
};
